import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import { VDRFileSourceType } from '../models/vdr-file-source-type.enum';

export interface RejectVDRFileUploadRequest {
    engagementId: number;
    fileId: number;
    fileSourceType: VDRFileSourceType;
}

export const RejectVDRFileUpload = createAsyncThunk(
    'dataRoom/rejectFileUpload',
    async (
        { engagementId, fileId, fileSourceType }: RejectVDRFileUploadRequest,
        { getState }: any
    ) => {
        const axios = getState().core.axios;

        try {
            const response = await axios.post(
                `api/VirtualDataRoomDocument/${engagementId}/file/${fileId}/reject-upload?fileSourceType=${fileSourceType}`
            );

            if (response.status !== 200) {
                createNotification(
                    'Could not reject file upload at the moment.',
                    'error'
                );
                throw new Error('Failed to reject file upload');
            }

            return fileId;
        } catch (error) {
            createNotification(
                'An error occurred while rejecting file upload.',
                'error'
            );
            throw error;
        }
    }
);

